<template>
  <!--<div id="app" class="container-fluid no-padding">
    <div class="row">
      <div class="col-md-2 d-none d-md-block bg-light"><leftbar/></div>
      <div class="col-md-10"><router-view/></div>
    </div>
  </div>-->
  <div id="app">
    <topbar />
    <router-view/>
  </div>
</template>

<script>
/* eslint-disable */
import LeftBar from '@/components/LeftBar'
import TopBar from '@/components/Topbar'

export default {
  name: 'App',
  computed : {
    isAppLoading: function() { return this.$store.getters.isAppLoading; }
  },
  data () {
    return {}
  },
  components: {
    'leftbar': LeftBar,
    'topbar' : TopBar
  },
  methods: { }
}
</script>
<style>
* {
  box-sizing: border-box;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #24292e;
}

body {
  background-color: #F9F9F9;
}

label {
  font-size: 14px;
  font-weight: 600;
  display: block;
  margin-bottom: 7px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue